import React from "react";
import TabFiles from "../../Files/TabFiles";

interface FilesTabProps {
  captureId: number;
  entityId: number;
}

const FilesTab: React.FC<FilesTabProps> = ({ captureId, entityId }) => {
  return (
    <TabFiles
      captureId={captureId}
      context="capture"
      entityId={entityId}
    />
  );
};

export default FilesTab;
